import React, { useContext, useState } from "react"
import clsx from "clsx"
import { Box, SvgIcon, Tooltip, Typography } from "@mui/material";
import EditIcon from "../../assets/images/icon/EditIcon";
import useStyles from "./TrackingClasses"
import { setTrackingState } from "../../store/actions/trackerAction";
import { TrackingContext } from "../../context/userTracking";
import { FontAwesomeIconRender, foundSelectedIcon, ICON_SLECTIN_TABS } from "../../components/IconSelectionPopOver";
import { fixOutcomeIcon } from "../../utils/staticDataJson";
import { baseEndpoints } from "../../services/config";
import { UserTypeContext } from "../../context/userStatus";
import { setOpenSubscriptionModal } from "../../store/actions/userTypeAction";
import MoveMetricPopover from "./MoveMetricPopover";
import OutcomeIcon from "../../assets/images/icon/ProgressInsights/OutcomeIcon";

const PersonalTrackingOutcome = ({ isExpand, item, categoryId = null, className = "", showMoveMetric = false, callservice }) => {
    const [showIcon, setshowIcon] = useState(false);
    const classes = useStyles()
    const { dispatch: trackingDispatch } =
        useContext(TrackingContext);
    const { state: outcomeState, dispatch: userTypeDispatch } = useContext(UserTypeContext);
    let foundIcon = foundSelectedIcon(item.icon)
    const iconisDefault = item.icon === fixOutcomeIcon[0].path
    return <td className={clsx(classes.cell, classes.stickyLeftCell, className)}>
        <div className={isExpand ? classes.mainDivClasExpand : classes.mainDivClas} style={{
            height: "100%",
            borderBottom: `1px solid var(--border-color)`,
        }}
            onMouseEnter={outcomeState.tutorialVisible ? () => { } : () => setshowIcon(true)}
            onMouseLeave={outcomeState.tutorialVisible ? () => { } : () => setshowIcon(false)}>
            <Box display={"flex"} alignItems={"center"} gap={"16px"}>
                {(item.icon && item.icon.length > 50) &&
                    !foundIcon ? (
                    <SvgIcon color="action" fontSize="small" width={"16px"} height={"16px"} sx={iconisDefault ? {
                        verticalAlign: "middle", width: "16px !important",
                        height: "16px !important",
                        fontSize: "16px", // Ensures consistent size
                    } : {
                        width: "16px !important",
                        height: "16px !important",
                        fontSize: "16px", // Ensures consistent size
                    }}>
                        <path d={item.icon} fill={iconisDefault ? "var(--color-new-main)" : ""} />
                    </SvgIcon>
                ) : item.icon && item.iconType ? (
                    item.iconType === ICON_SLECTIN_TABS.EMOJI ? <span style={{
                        height: "16px",
                        width: "16px",
                        fontSize: "16px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}>{item.icon}</span> :
                        item.iconType === ICON_SLECTIN_TABS.ICON ? <FontAwesomeIconRender selectedIcon={item.icon} style={{
                            height: "16px",
                            width: "16px",
                        }} /> :
                            item.iconType === ICON_SLECTIN_TABS.IMAGE ? <img
                                alt="toggl"
                                width="16px" height="16px"
                                src={
                                    item.icon
                                        ? `${baseEndpoints.getImage}${item.icon}`
                                        : "/toggl.png"
                                }
                                style={{
                                    height: "16px",
                                    width: "16px",
                                    borderRadius: "10px"
                                }}
                            /> : null
                ) : null}
                {item.description ? (
                    <Tooltip
                        title={
                            <Typography sx={{ fontSize: "14px !important", lineHeight: "1.5", whiteSpace: "pre-wrap" }}>
                                {item.description}
                            </Typography>
                        }
                    >
                        <div style={{
                            width: '100%',

                            height: "100%"
                        }}>
                            <Typography variant="h6" flex={7} title={item.name} className={isExpand ? classes.fullTexttextClass : classes.textClass}>
                                {" "}
                                {item.name}
                            </Typography>
                        </div>
                    </Tooltip>
                ) : (
                    <div style={{
                        width: '100%',
                        height: "100%"
                    }}>
                        <Typography variant="h6" flex={7} title={item.name} className={isExpand ? classes.fullTexttextClass : classes.textClass}>
                            {" "}
                            {item.name}
                        </Typography>
                    </div>
                )}
            </Box>
            {showIcon && <Box display={"flex"} alignItems={"center"} gap={"6px"}>
                {showMoveMetric && <MoveMetricPopover
                    sourceCategoryId={categoryId}
                    metricType="outcome"
                    metricId={item?.outcomeId || item?._id}
                    journeyCategoryList={outcomeState?.journeyCategoryList || []}
                    token={outcomeState?.token}
                    restricted={outcomeState?.restrictUser}
                    onRestricted={() => userTypeDispatch(setOpenSubscriptionModal(true))}
                    callservice={callservice}
                    trackingDispatch={trackingDispatch}
                />}
                <span
                    onClick={() => outcomeState.restrictUser ? userTypeDispatch(setOpenSubscriptionModal(true)) : trackingDispatch(setTrackingState({
                        openStartModal: true,
                        showOutcome: true,
                        outComeValue: item,
                        outcomeId: item._id,
                        categoryId: categoryId
                    }))}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        height: "100%"
                    }}
                >
                    <EditIcon />
                </span>
            </Box>}
        </div>
    </td>
}

export default PersonalTrackingOutcome